<div class="model-content-footer">
  <div class="spacer"></div>
  <ng-content></ng-content>
</div>
